/**
 * MetaFlow API — Waba /api/messaging/flows (Meta WhatsApp Flows product)
 */
import apiClient from 'services/apiClient';

export const META_FLOW_CATEGORIES = [
  'SIGN_UP',
  'SIGN_IN',
  'APPOINTMENT_BOOKING',
  'LEAD_GENERATION',
  'CONTACT_US',
  'CUSTOMER_SUPPORT',
  'SURVEY',
  'OTHER',
];

export const listMetaFlows = (params = {}) =>
  apiClient.get('messaging/flows', { params }).then((res) => res.data);

export const listLocalMetaFlows = () =>
  apiClient.get('messaging/flows/local').then((res) => res.data);

export const syncMetaFlows = () =>
  apiClient.post('messaging/flows/sync').then((res) => res.data);

export const getMetaFlow = (flowId) =>
  apiClient.get(`messaging/flows/${flowId}`).then((res) => res.data);

export const createMetaFlow = (payload) =>
  apiClient.post('messaging/flows', payload).then((res) => res.data);

export const updateMetaFlow = (flowId, payload) =>
  apiClient.put(`messaging/flows/${flowId}`, payload).then((res) => res.data);

export const publishMetaFlow = (flowId) =>
  apiClient.post(`messaging/flows/${flowId}/publish`).then((res) => res.data);

export const deprecateMetaFlow = (flowId) =>
  apiClient.post(`messaging/flows/${flowId}/deprecate`).then((res) => res.data);

export const deleteMetaFlow = (flowId) =>
  apiClient.delete(`messaging/flows/${flowId}`).then((res) => res.data);

/** Mid-flow progress + completed webhook responses */
export const listMetaFlowSubmissions = (params = {}) =>
  apiClient.get('messaging/flow-submissions', { params }).then((res) => res.data);

export const getMetaFlowSubmission = (id) =>
  apiClient.get(`messaging/flow-submissions/${id}`).then((res) => res.data);

/** @deprecated Use listMetaFlows — kept for template FLOW button picker */
export const GetFlows = async () => {
  const data = await listMetaFlows();
  return data?.data || [];
};
